import styled from "styled-components";
import { NavLink } from "react-router-dom";
import bg1 from "./assets/Graphics/bg1.png";


export const Container = styled.div`
  /* max-width: 900px; */
  /* position: relative; */
  margin: 2em clamp(0.1em, 8vw, 300px);

  @media (max-width: 576px) {
    margin: 0 0.8em;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  width: 100%;
  max-width: 900px;
  margin: 2em auto;
  position: relative;
  overflow: visible;

  background-color: #caa0371f;
  border: 0.5px solid #5c0630;
  border-radius: 16px;

  @media (max-width: 576px) {
    padding: 1rem;
  }
`;

export const Title = styled.h1`
  font-size: 2rem;
  color: #344b45;
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 2em;
  span {
    display: block;
    font-size: 16px;
    padding: 1em;
  }
`;

export const H3 = styled.h3`
  /* color: #273743; */

  text-align: center;
  font-family: ${(props) => props.lang === "fa" ? "Tanha, sans-serif" : "Purisa, sans-serif"};

  font-size: clamp(20px, 2.2vw, 5em);
  padding: 0.7em 0;
  /* text-transform: uppercase; */
  letter-spacing: -1px;

  background-image: url(${bg1});
  line-height: 1.3em;
  background-size: contain;
  /* background-size: auto; */
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  /* background-color: red; */
  text-align: center;
  margin: 1em auto;
  max-width: 14em;
`;

export const Description = styled.p`
  font-size: 1rem;
  color: #4a5d58;
  text-align: center;
  line-height: 1.5;
  padding-bottom: 1em;
`;

export const ShapeTopLeft = styled.div`
  position: absolute;
  /* background-color: #c39442; */
  border-radius: 8px;
  top: -3em;
  left: ${(props) => props.lang === "en" ? "0" : "70px"};
  right: ${(props) => props.lang === "en" ? "0" : "70px"};
  object-fit: contain;

  img {
    width: 150px;
    height: 150px;
  }
  @media (max-width: 768px) {
    left: auto;
  }
`;


export const ShapeBottomRight = styled.div`
  position: absolute;
  img {
    width: 170px;
    height: 170px;
  }
  /* background-color: #c39442; */
  /* border: 0.1px solid black; */
  border-radius: 8px;
  bottom: -4em;
  right: 70px;
  object-fit: contain;
  @media (max-width: 768px) {
    right: auto;
  }
`;

export const MenuLink = styled(NavLink)`
  color: ${(props) => props.theme.colors.txt.color1};
  text-decoration: none;
  padding: 0 16px;
  &:hover {
    color: ${(props) => props.theme.colors.txt.color4};
    /* transform: scale(1.05); */
    transition: transform 0.2s;
    /* font-weight: 700; */
  }
  /* font-size: clamp(12px, 1.2vw, 2em);
  color: ${(props) => props.theme.colors.colorbg};
  text-decoration: none;
  margin: 0 15px; */

  /* transition: all .2s  */
`;



export const Projects = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;



export const Card = styled.div`
    position: relative;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border-radius: 15px;
    margin-bottom: 130px;
    width: 250px;

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    }
  `

export const Thumbnail = styled.div`
    overflow: hidden;

    img {
      width: 100%;
      min-height: 180px;
      max-height: 180px;
      object-fit: cover;
      transition: transform 0.3s ease;
      border-radius: 15px;
    }

    &:hover img {
      transform: scale(1.02);
    }
  `

export const CardContent = styled.div`
    position: absolute;
    background-color: #ddd;
    width: 100%;
    height: 100%;
    max-height: 140px;
    // padding: 1em 0.8em;
    top: 130px;
    z-index: 2;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  `

export const CardTitle = styled.h3`
    padding: 1em .5em;
    font-size: 1.1rem;
    text-align: center;
    margin: 0;

    a {
      color: #942525ff;
      text-decoration: none;
      transition: 0.2s ease;

      &:hover {
        font-weight: 900;
      }
    }
  `

export const Footer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: auto;
    font-size: 11px;
    border-top: 1px dashed #505050ff;
    align-items: center;
    padding: .2em 0;
    // height:100%;
    // background-color: red;

    a {
      text-decoration: none;
      color: #3d3b3bff;
    }
  `